import {
  Box,
  Divider,
  GridItem,
  Input,
  SimpleGrid,
  Text,
} from "@chakra-ui/react";
import React from "react";
import SectionDivider from "../Common/SectionDivider";
import CaseNote from "./CaseNote";
import ScrollCircle from "../Common/ScrollCircle";

const FormComponent = ({ data }) => {
  // field render
  const renderFields = (fields) => {
    return Object.keys(fields).map((fieldKey) => {
      const field = fields[fieldKey];

      if (Array.isArray(field)) {
        if (
          field &&
          field != null &&
          field.length > 0 &&
          Object?.keys(field?.[0])?.length === 1
        ) {
          return field.map((item, idx) => {
            return Object?.keys(item).map((innerKey) => (
              <>
                {idx === 0 && (
                  <GridItem colSpan={{ base: 1, md: 3 }}>
                    <Text fontWeight={500} fontSize="lg">
                      {fieldKey}
                    </Text>
                  </GridItem>
                )}
                <Box key={innerKey}>
                  <Text fontWeight={500}>{item[innerKey]?.MESSAGE}</Text>
                  <Input
                    value={item[innerKey]?.VALUE || ""}
                    isReadOnly={!item[innerKey]?.EDITABLE}
                  />
                </Box>
              </>
            ));
          });
        }
        return field.map((item, idx) => {
          return (
            <GridItem colSpan={{ base: 1, md: 3 }}>
              <SimpleGrid columns={[1, 2, 3]} spacing={4}>
                {Object.keys(item).map((innerKey) => (
                  <Box key={innerKey} mb={4}>
                    <Text fontWeight={500}>{item[innerKey]?.MESSAGE}</Text>
                    <Input
                      value={item[innerKey]?.VALUE || ""}
                      isReadOnly={!item[innerKey]?.EDITABLE}
                    />
                  </Box>
                ))}

                {/* Add a Divider except after the last group */}
                {idx !== field.length - 1 && (
                  <GridItem colSpan={{ base: 1, md: 3 }}>
                    <Divider my={2} h="2px" bg="gray.100" />{" "}
                  </GridItem>
                )}
              </SimpleGrid>
            </GridItem>
          );
        });
      } else if (typeof field === "object") {
        return (
          <Box key={fieldKey} mb={4}>
            <Text fontWeight={500}>{field.MESSAGE}</Text>
            <Input value={field.VALUE || ""} isReadOnly={!field.EDITABLE} />
          </Box>
        );
      }
      return null;
    });
  };

  const renderSections = () => {
    return Object.keys(data).map((sectionKey) => {
      const section = data[sectionKey];
      return (
        <Box key={sectionKey} mb={8} px={5}>
          <Box my={5}>
            <SectionDivider message={section.MESSAGE} />
          </Box>
          <SimpleGrid columns={[1, 2, 3]} spacing={4}>
            {section?.MESSAGE !== "Case Notes" ? (
              renderFields(section.FIELDS)
            ) : (
              <CaseNote caseData={section?.FIELDS?.CASE_NOTES} />
            )}
          </SimpleGrid>
        </Box>
      );
    });
  };

  return (
    <Box mt={2}>
      <Box position="fixed" left={2} top="20%">
        <ScrollCircle data={data} />
      </Box>
      {renderSections()}
      <Divider my={4} />
    </Box>
  );
};

export default FormComponent;
